module.exports = __webpack_public_path__ + "img/skrill.5f7cd7f9.png";